import { useRef, useState } from 'react';
import { message } from 'antd';
import type { VoiceOptionValue } from '../types';

export const useVoicePreview = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [playingVoice, setPlayingVoice] = useState<VoiceOptionValue | null>(
    null
  );

  const handleVoiceToggle = (
    voiceValue: VoiceOptionValue,
    previewUrl?: string
  ) => {
    if (!previewUrl) return;

    if (playingVoice === voiceValue && audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
      setPlayingVoice(null);
      return;
    }

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }

    const audio = new Audio(previewUrl);
    audioRef.current = audio;

    audio.play().catch(() => {
      message.error('Unable to play voice preview');
      setPlayingVoice(null);
      audioRef.current = null;
    });

    audio.onended = () => {
      setPlayingVoice(null);
      audioRef.current = null;
    };

    setPlayingVoice(voiceValue);
  };

  return { playingVoice, handleVoiceToggle };
};
